import { renderIcon, type IconKey } from './icons';

export type MetricTrend = 'up' | 'down' | 'flat';

export type MetricCardProps = {
  label: string;
  value: string;
  unit?: string;
  trend?: MetricTrend;
  trendLabel?: string;
  /** When true, render value in neutral text instead of gold. */
  neutral?: boolean;
  icon?: IconKey;
};

const trendGlyph: Record<MetricTrend, string> = {
  up: '▲',
  down: '▼',
  flat: '–'
};

function MetricCard({
  label,
  value,
  unit,
  trend,
  trendLabel,
  neutral,
  icon
}: MetricCardProps) {
  const valueClass = neutral
    ? 'axi-metric-card__value axi-metric-card__value--secondary'
    : 'axi-metric-card__value';

  return (
    <article className="axi-metric-card">
      <span className="axi-metric-card__icon" aria-hidden="true">
        {icon ? renderIcon(icon, 22) : null}
      </span>
      <div className="axi-metric-card__body">
        <p className="axi-metric-card__label">{label}</p>
        <p className={valueClass}>
          {value}
          {unit ? <span className="axi-metric-card__unit"> {unit}</span> : null}
        </p>
        {trend ? (
          <span className={`axi-metric-card__trend is-${trend}`}>
            <span aria-hidden="true">{trendGlyph[trend]}</span>
            <span>{trendLabel ?? trend}</span>
          </span>
        ) : null}
      </div>
    </article>
  );
}

export default MetricCard;